import React from 'react';
import { useTranslation } from 'react-i18next';
import { CountrySelect, Form, SelectInput } from '@thinknet-gmbh/platform-common-ui';

import { Skills } from '../skills';
import { WithSwitcherFields } from '../with-switcher-field';
import { CheckBoxField } from '../checkBox-field';
import { MiniJobDocument } from '../mini-job-document';
import { Signature } from '../signature';
import { PersonalIdCard } from '../personal-id-card';
import { HealthInsuranceCard } from '../health-insurance-card';
import AutocompleteSelectComponent from '../../../../../autocomplete-select/autocomplete-select.component';

import { FORM_ITEMS_TYPE } from '../../../../questionnaire-page.constants';
import { IQuestionnaireFieldProps } from './form-item-field.intrrface';
import { FormItemContainer } from '../../../../questionnaire-page.styles';


const FormItem = ({
  inputType,
  inputProps = {},
  selectOptions = [],
  label,
  itemWidth,
  InputComponent,
  ...rest
}: IQuestionnaireFieldProps) => {
  if (!InputComponent) {
    return null;
  }
  return (
    <FormItemContainer itemWidth={itemWidth}>
      <Form.Item label={label} {...rest}>
        {inputType === FORM_ITEMS_TYPE.select ? (
          <InputComponent {...inputProps}>
            {selectOptions.map(el => (
              <SelectInput.Option value={el?.value} key={el.value}>
                {el?.label}
              </SelectInput.Option>
            ))}
          </InputComponent>
        ) : (
          <InputComponent {...inputProps} />
        )}
      </Form.Item>
    </FormItemContainer>
  );
};

const CountryFormItem = ({
  inputProps = {},
  label,
  inputType,
  itemWidth,
  ...rest
}: IQuestionnaireFieldProps) => {
  const { t } = useTranslation(['common']);
  return (
    <FormItemContainer itemWidth={itemWidth}>
      <Form.Item label={label} {...rest}>
        <CountrySelect t={t} {...inputProps} />
      </Form.Item>
    </FormItemContainer>
  );
};

const AutocompleteSelectItem = ({
  inputProps = {},
  label,
  inputType,
  itemWidth,
  ...rest
}: IQuestionnaireFieldProps) => (
  <FormItemContainer itemWidth={itemWidth}>
    <Form.Item label={label} {...rest}>
      <AutocompleteSelectComponent {...inputProps} />
    </Form.Item>
  </FormItemContainer>
);

const getComponent = (componentType: string) => {
  switch (componentType) {
    case FORM_ITEMS_TYPE.customSkillsComponent:
      return Skills;
    case FORM_ITEMS_TYPE.withSwitcher:
      return WithSwitcherFields;
    case FORM_ITEMS_TYPE.checkbox:
      return CheckBoxField;
    case FORM_ITEMS_TYPE.miniJobDocument:
      return MiniJobDocument;
    case FORM_ITEMS_TYPE.signature:
      return Signature;
    case FORM_ITEMS_TYPE.country:
      return CountryFormItem;
    case FORM_ITEMS_TYPE.autocomplete:
      return AutocompleteSelectItem;
    case FORM_ITEMS_TYPE.personalIdCard:
      return PersonalIdCard;
    case FORM_ITEMS_TYPE.healthInsuranceCard:
      return HealthInsuranceCard;
    default:
      return FormItem;
  }
};

const FormItemFields = ({ inputType, ...rest }: IQuestionnaireFieldProps) => {
  const Component = getComponent(inputType);
  return <Component inputType={inputType} {...rest} />;
};

export default FormItemFields;
